export const formatMoney = (
    amount, decimalCount = 2, decimalSeparator = ".", thousandsSeparator = ","
) => {
    if (amount === undefined || amount === null) return undefined
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        const j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign
            + (j ? i.substr(0, j) + thousandsSeparator : '')
            + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandsSeparator)
            + (decimalCount ? decimalSeparator + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
    }
}

export const CurrencyOptions = {
    CANADIAN_DOLLAR: { label: "CAD", symbol: "C$", currencyIndex: 1 },
    UNITED_STATE_DOLLAR: { label: "USD", symbol: "US$", currencyIndex: 2 },
}

export const DefaultCurrencyOption = CurrencyOptions.CANADIAN_DOLLAR;

export const getCurrencyByIndex = (index) => {
    return Object.values(CurrencyOptions).find(v => v.currencyIndex === index)
}

export const GetCurrencyOptionItems = () => {
    const currencyOptions = Object.values(CurrencyOptions);
    return currencyOptions.map(v => ({ label: v.label, value: v.currencyIndex }));
}

export const GetSelectedCurrencyOptionItem = (selectedCurrencyIndex) => {
    const currencyOptionItems = GetCurrencyOptionItems();
    return currencyOptionItems?.find(v => v.value === selectedCurrencyIndex) ?? '';
}

/**
 * Returns currency options with exchange rate subLabels for dropdown display.
 * @param {Record<number, number>|null} currencies - Map of currencyIndex to rate (1 CAD = rate in that currency)
 */
export const getCurrencyOptionsWithRates = (currencies) => {
    const options = Object.values(CurrencyOptions);
    if (currencies == null) {
        return options.map(opt => (opt.currencyIndex === 1 ? { ...opt } : { ...opt, subLabel: '—' }));
    }
    return options.map(opt => {
        if (opt.currencyIndex === 1) return { ...opt }; // CAD is base, no rate needed
        const rate = currencies[opt.currencyIndex];
        const rateStr = rate != null ? Number(rate).toFixed(4) : '—';
        return { ...opt, subLabel: `1 CAD = ${rateStr} ${opt.label}` };
    });
}
